import { z } from 'zod';
import { WorkbenchRecordTarget } from './workbench-record.js';
const sha = z.string().regex(/^[a-f0-9]{64}$/);
/** Provenance for the bytes actually returned by a private working-PDF render.
 * This is not a release, retained-file receipt or proof of historical costing. */
export const ProposalRenderReceipt = z.object({
    contract: z.literal('aiw.proposal-render-receipt/1'), receipt_id: z.uuid(),
    audience: z.literal('emma-review-document'), actor_id: z.uuid(), test_set_id: z.uuid().nullable(),
    proposal_id: z.uuid(), revision_id: z.uuid(), version: z.number().int().positive(), kind: z.literal('working'),
    content_sha256: sha, document_source_sha256: sha, pricing_projection_sha256: sha,
    pdf_sha256: sha, pdf_bytes: z.number().int().min(5).max(32 * 1024 * 1024),
    rendered_at: z.iso.datetime({ offset: true }), retain_before: z.iso.datetime({ offset: true }),
}).strict();
/** Durable provenance; current authentication and source access remain mandatory.
 * V1 stays readable only within its original deadline. New renders emit V2. */
export const DurableProposalRenderReceipt = ProposalRenderReceipt.omit({ retain_before: true }).extend({
    contract: z.literal('aiw.proposal-render-receipt/2'),
}).strict();
export const AnyProposalRenderReceipt = z.discriminatedUnion('contract', [ProposalRenderReceipt, DurableProposalRenderReceipt]);
export const VerifyProposalRenderReceipt = WorkbenchRecordTarget.safeExtend({
    proposal_id: z.uuid().transform(v => v.toLowerCase()), revision_id: z.uuid().transform(v => v.toLowerCase()),
    pdf_sha256: sha, pdf_bytes: z.number().int().min(5).max(32 * 1024 * 1024), receipt: z.string().min(1).max(4096),
});
//# sourceMappingURL=proposal-render-receipt.js.map